import { ExternalLink, Gift, Heart, Smartphone, CreditCard } from 'lucide-react'

const registryItems = [
  {
    id: 3,
    name: 'Honeymoon Fund',
    description: 'We\'re planning an amazing honeymoon adventure! If you\'d like to contribute to our honeymoon fund, it would mean the world to us. Every contribution helps us create unforgettable memories together.',
    color: 'bg-pink-500',
    type: 'honeymoon',
    paymentMethods: [
      {
        name: 'Venmo',
        handle: '@Eduardo-RiosJr',
        url: 'https://account.venmo.com/u/Eduardo-RiosJr',
        icon: Smartphone,
        color: 'bg-blue-500',
      },
      {
        name: 'Zelle',
        handle: '+1 (956) 844-2121',
        icon: CreditCard,
        color: 'bg-purple-500',
      },
    ],
  },
  {
    id: 2,
    name: 'Crate & Barrel',
    description: 'Beautiful home decor and furniture for our home.',
    url: 'https://www.crateandbarrel.com/gift-registry/naetzy-ramos-and-eduardo-rios/r7388249',
    icon: 'crate-barrel',
    color: 'bg-blue-600',
    type: 'external',
  },
]

export function Registry() {
  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="section-padding">
        <div className="container-max">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-serif text-primary-900 mb-4">
              Registry
            </h1>
            <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
              Your presence at our wedding is the greatest gift of all! 
              If you wish to honor us with a gift, we've registered at a few of our favorite places.
            </p>
          </div>

          <div className="max-w-2xl mx-auto space-y-8 mb-12">
            {registryItems.map((item) => (
              <div key={item.id} className="card p-8">
                <div className={`${item.color} w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center`}>
                  {item.type === 'honeymoon' ? (
                    <Heart className="h-8 w-8 text-white" />
                  ) : (
                    <Gift className="h-8 w-8 text-white" />
                  )}
                </div>
                
                <h3 className="text-xl font-serif text-primary-900 mb-3 text-center">
                  {item.name}
                </h3>
                
                <p className="text-neutral-600 mb-6 text-center">
                  {item.description}
                </p>
                
                {item.type === 'external' ? (
                  <div className="text-center">
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-primary inline-flex items-center gap-2"
                    >
                      Visit Registry
                      <ExternalLink className="h-4 w-4" />
                    </a>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {item.paymentMethods?.map((method, index) => (
                      <div key={index} className="flex items-center justify-between p-4 bg-primary-50 rounded-lg">
                        <div className="flex items-center gap-3">
                          <div className={`${method.color} w-10 h-10 rounded-full flex items-center justify-center`}>
                            <method.icon className="h-5 w-5 text-white" />
                          </div>
                          <div>
                            <h5 className="font-semibold text-primary-900">{method.name}</h5>
                            <p className="text-sm text-neutral-600">{method.handle}</p>
                          </div>
                        </div>
                        {method.url && (
                          <a
                            href={method.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-secondary text-xs sm:text-sm px-2 py-1 sm:px-3 sm:py-2"
                          >
                            <span className="hidden sm:inline">Send via {method.name}</span>
                            <span className="sm:hidden">Send</span>
                          </a>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>


        </div>
      </div>
    </div>
  )
} 